import { observer } from "mobx-react";
import cn from "clsx";
import EmptyPage from "../emptyPage";
import styles from "./index.module.scss";
import UKTruncatedTooltip from "@/common-components-src/components/UKTruncatedTooltip";
import { LogisticsInfoDTOListVo } from "@/app/csr-src/apis/order/order.interface";

interface stepperProps {
  logisticsInfoDTOList: LogisticsInfoDTOListVo[];
}

const stepper: React.FC<stepperProps> = observer(({ logisticsInfoDTOList }) => {
  return logisticsInfoDTOList?.length ? (
    logisticsInfoDTOList.map((item, index) => {
      return (
        <div
          key={index}
          className={cn(styles.stepper_item, { [styles.active_stepper_item]: index === 0 })}
        >
          <div className={styles.divider_wrap}>
            <i className={styles.dot_style} />
            {index !== logisticsInfoDTOList.length - 1 ? <i className={styles.line_style} /> : null}
          </div>
          <div className={styles.title_wrap}>
            {item.stateDesc ? <div className={styles.title_style}>{item.stateDesc}</div> : null}
            {item.message ? (
              <UKTruncatedTooltip
                text={item.message}
                tooltipStyles={cn(styles.sub_title_style)}
                tooltipProps={{ placement: "top" }}
                textLines={2}
              />
            ) : null}
            <UKTruncatedTooltip
              text={item?.position}
              tooltipStyles={cn(styles.detail_address_style)}
              tooltipProps={{ placement: "top" }}
              textLines={2}
            />
            <div className={styles.date_style}>
              {item?.messageDate}, {item?.messageTime}
            </div>
          </div>
        </div>
      );
    })
  ) : (
    <div className={styles.wrap}>
      <EmptyPage
        externalStyles={{ padding: "40px 0" }}
        externalImageStyles={{ width: "72px", height: "72px" }}
      />
    </div>
  );
});

export default stepper;
